import * as React from 'react';
import { DatePicker as DatePickerInput, DatePickerProps } from 'antd';
import styles from './styles.module.scss';
import moment from 'moment';

const AntdDatePicker = ({ ...props }: DatePickerProps): React.ReactElement => (
  <DatePickerInput
    autoComplete="chrome-off"
    inputReadOnly
    format={'DD/MM/YYYY'}
    allowClear={false}
    defaultValue={moment(Date.now())}
    className={styles.ant_picker}
    {...props}
  />
);

export default AntdDatePicker;
